module.exports = __webpack_public_path__ + "themify.2c454669bdf3aebf32a1.eot";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/fonts/themify.eot
// module id = ../../../../../src/assets/fonts/themify.eot
// module chunks = styles